import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=62008368&"
import script from "./PaymentStep.vue?vue&type=script&lang=js&"
export * from "./PaymentStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports